function NoTechs() {
  return (
    <div
      style={{
        width: "90%",
        height: "200px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "space-around",
      }}
    >
      <p
        style={{
          fontFamily: "Inter",
          fontSize: "25px",
          color: "white",
          fontWeight: "600",
        }}
      >
        Sem tecnologias
      </p>
      <p
        style={{
          fontFamily: "Inter",
          fontSize: "18px",
          color: "white",
        }}
      >
        Adicione tecnologias para ve-las aqui
      </p>
    </div>
  );
}
export default NoTechs;
